import JSEncrypt from "jsencrypt";

const pubKey = `MIICIjANBgkqhkiG9w0BAQEFAAOCAg8AMIICCgKCAgEAt5E/CQpZExOb05I9rcsfxIc2doaQ4MxeTX5RyMoLftXGXjcc/bjsLlstK9aOfyZCLE7T31w7Qk8M9byR4GyrnSXluLtqz8KPK95NXMjs63tKpHSo4OwGcLCTkhL18DitQEd9Vxr5dlzugk+WxhZMpOTkKjgTjVDuSe3XNAa0QNzXrMZtcswOa1CPEXYYgD9rytFH5n4ouwGZCNPVGv/mWQTskjb5pzWWbcw0G18cNAUqw2lJZ05CPkSKgbpoi5KgYTVl3hv9+F1peoEr3RM9sv5QhpT3A7qOpfJKj5VxSeg6eUadQBrZQrV/7ue9tItB+zcVFZH20WcLfjMwF/fmrbfvJdUyDrvSzY+T7BepU2vGO39yECJGxEHLQtCP1smh7mU9WOVNarNiPJbAeZ/U3SWlyZ/is5+tfqZIkYfVHwugAoRFLeZzoY38+13NdZD76ZQge3m5Pu2VsDfpDO9m1atiqOS+GRH4+/4txyYgfhANdlXV1CjHRxDE8LESrEVspL5PSVnLjXxsb9UJFhU1E5TKwLSx27X6mixoWiqawZRJc3Yx2Prymm+p25JDn3+o+MxjNBzN1K34n/OccLnL3w18+HG5vkoL28pqG8wJ24m6Bkdq+DUMkaFfO7cbrV0IFbyLetvpohDnCC4zWIUAahAlOKlgSMjJOIXrgsiCU3kCAwEAAQ==`;

const encrypt = new JSEncrypt();
encrypt.setPublicKey(pubKey);

function Encrypt(str) {
  let data = encrypt.encrypt(str.toString());
  return data;
}

function Decrypt(str) {
  let data = encrypt.decrypt(str.toString());
  return data;
}

export default {
  Encrypt,
  Decrypt,
};



// WEBPACK FOOTER //
// ./src/utils/rsaUtils.js